import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Box, Grid, TextField, Button, Typography } from "@material-ui/core";
import useStyles from "../../themes/makeStyles";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import ActionTypes from "../../common/constants/ActionTypes";
import FormValidationErrorMessage from "../../components/FormValidationErrorMessage";
import Notification from "../../components/Notifications/index.js";
import AutocompleteController from "../../components/AutoCompleteController";
import { get_warehouse_code_by_name, list_warehouse_master_by_email, authentication_email } from "../../common";
import logo from "../../assets/logo.svg";
import { get_master_data } from "../../common";
import jwt from 'json-web-token'

export default function AzureLogin(props) {
  const accounts = props && props.accounts;

  const [resetvalues, SetResetvalues] = React.useState(false);
  const [warehouseData, setWarehouseData] = React.useState([]);
  const [warehouseCodes, setWarehouseCodes] = React.useState([]);
  const [StoreID, setStoreID] = React.useState();
  const [loginDisabled, setLoginDisabled] = React.useState(false);

  const history = useHistory();

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  let defaultValues = {
    warehouse_name: null,
    warehouse_code: "",
  };

  const {
    handleSubmit,
    setValue,
    control,
    errors,
  } = useForm({ defaultValues });

  const wareHouseNames = {
    options: warehouseData,
  };

  const SuccessErrMsg = (pass_msg, msg_type) => {
    setNotify({
      isOpen: true,
      message: pass_msg,
      type: msg_type,
      timing: 2000,
    });
  }

  const getWareHouseId = (value) => {
    let postobj = { warehouse_name: value };
    get_warehouse_code_by_name(postobj).then((data) => {
      if (data.Records === null) {
        SuccessErrMsg(`Selected warehouse doesn't have code.Please select another warehouse `, "error")
        setValue("warehouse_code", "");
      } else {
        setValue("warehouse_code", data?.Records[0][0]?.warehouse_code);
      }
    });
  };

  const handleReceiveMessageFromParent = (event) => {
    const receivedMessage = event.data;
    if (receivedMessage.token && receivedMessage.user_email)
      handleMessage(receivedMessage);
  };

  const handleMessage = async (e) => {
    sessionStorage.setItem('token', e.token);
    sessionStorage.setItem('user_email', e.user_email);
    let postobj = { email: e.user_email };

    jwt.signin('WAREHOUSE', postobj, function (err2, userEmail) {
      authentication_email(userEmail).then(res => {
        sessionStorage.setItem('token', res.token)

        if (res.issuccess === 1) {
          list_warehouse_master_by_email(postobj, res.token).then((data) => {
            if (data.Records[0] == null) {
              SuccessErrMsg(`Warehouse list not assigned to ${e.user_email}, Please contact administrator`, "error")
            } else {
              setWarehouseData(data.Records[0][0].warehouselist.split(","));
              sessionStorage.setItem("user_type", data.Records[0][0].user_type)
              setStoreID(data.Records[0][0].id)
              setWarehouseCodes(data.Records[0][0].warehouse_codes)
            }
          });
        }
      })
    });
  }

  useEffect(() => {
    window.addEventListener('message', handleReceiveMessageFromParent);
    const responseMessage = 'Hello from the iframe!';
    window.parent.postMessage(responseMessage, window.origin);
    return () => {
      // Clean up the event listener
      window.removeEventListener('message', handleReceiveMessageFromParent);
    };
  }, [])

  useEffect(() => {
    if ((props && props.accounts && accounts.username) || (window.top !== window.self && sessionStorage.getItem('user_email'))) {
      let postobj = {};
      if (window.top !== window.self) {
        postobj = { email: sessionStorage.getItem('user_email') };
      } else {
        postobj = { email: accounts.username };
      }
      const expirationTime = Math.floor(Date.now() / 1000) + 5; 
      postobj.expiry = expirationTime;

      jwt.encode('WAREHOUSE', postobj, function (err2, userEmail) {

        if (err2) {
          console.error(err2);
        } else {
        authentication_email(userEmail).then(res => {
              // authentication_email('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6Im1zckB0bWlsbHRkLmNvbSIsImV4cCI6MTc0MTMzMzM4Mn0.csyzyFFDRbA1DeTHzwyqyJpgZM_MpFnkWiU3g6Y73EU').then(res => {
          sessionStorage.setItem('token', res.token)

          if (res.issuccess === 1) {
            list_warehouse_master_by_email(postobj, res.token).then((data) => {
              if (data.Records[0] == null) {
                SuccessErrMsg(`Warehouse list not assigned to ${window.top !== window.self ? sessionStorage.getItem('user_email') : accounts.username}, Please contact administrator`, "error")
              } else {
                setWarehouseData(data.Records[0][0].warehouselist.split(","));
                sessionStorage.setItem("user_type", data.Records[0][0].user_type)
                setStoreID(data.Records[0][0].id)
                setWarehouseCodes(data.Records[0][0].warehouse_codes)
              }
            });
          }
        })
        }
      })
    } else {
      setTimeout(function () {
        history.push(`/${ActionTypes.LOB}/`)
      }, 100)
    }
  }, [props.accounts]);

  const onSubmit = async (data) => {
    setLoginDisabled(true)
    let damageObj = {
      warehouse_code: data.warehouse_code,
      warehouse_name: data.warehouse_name,
    };

    let LoginObj = {
      pageType: "userLogin",
      name: window.top !== window.self ? sessionStorage.getItem('user_email') : accounts.username,
      password: window.top !== window.self ? sessionStorage.getItem('user_email') : accounts.username,
      WmsLogin: true,
      id: StoreID
    };

    sessionStorage.setItem("login", JSON.stringify(LoginObj));
    sessionStorage.setItem("warehouseData", JSON.stringify(damageObj));
    sessionStorage.setItem("warehouseCodes", JSON.stringify(warehouseCodes));

    let queryParam = {
      warehouse_code: data.warehouse_code
    }

    SuccessErrMsg(`WMS Login Success`, "success")

    setTimeout(function () {
      setLoginDisabled(false);
      history.push(`/${ActionTypes.LOB}/dashboard`);

      // master data
      if (window.top === window.self) {
        get_master_data(queryParam).then((masterdata) => {
          props.setMasterObjects(masterdata);
        });
      }

    }, 2000);
  };

  // const LogOut = () => {
  //   props.logout()
  // }

  function Footer() {
    const classes = useStyles();
    return (
      <Box pt={2}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              form="headerjob"
              className={clsx(classes.subTextButton, "loginBtn")}
              disabled={loginDisabled}
            >
              Submit
            </Button>
          </Grid>

          {/* <Grid item>
            <Button
              variant="outlined"
              // color=""
              type="button"
              form="headerjob"
              className={clsx(classes.subTextButton, "loginBtn")}
              onClick={LogOut}
            >
              Log Out
            </Button>
          </Grid> */}
        </Grid>
      </Box>
    );
  }

  const loginMS = () => {
    props.LoginFunction()
  }

  const classes = useStyles();

  return (
    <div className="d-flex flex-column flex-root">
      <div className="login d-flex flex-column flex-lg-row flex-column-fluid w-100 login-root">
        <div className="login-aside order-2 order-lg-1 d-flex flex-row-auto position-relative overflow-hidden">
          <div className="d-flex flex-column-fluid flex-column justify-content-between w-100 px-5 py-6 box-sizing">
            <Box textAlign="center"
              style={{ marginTop: window.top !== window.self ? '60px' : '' }}>
              <img src={logo} alt="Kitty Katty!" className="logo_login" />
            </Box>
            <div className="d-flex flex-column-fluid flex-column flex-center">
              <div class="loginTitle">
                {((accounts && accounts.username) || window.top !== window.self) ? (
                  <Box pt={2}>
                    <h3 textAlign="center">
                      {((accounts && accounts.username) || window.top !== window.self)
                        ? "You are logged in as " + (window.top !== window.self ? sessionStorage.getItem('user_email') : accounts.username)
                        : ""}
                    </h3>

                  </Box>
                ) : (<>

                  <Box py={1}>
                    <h2 className="borderBottom">Welcome to Warehouse !</h2>
                  </Box>
                  <p>Login to Your Account to continue</p>
                  <Box pt={3}>
                    <Button color="primary" fullWidth onClick={() => loginMS()} className={clsx(classes.subTextButton, "loginBtn")} variant="contained" >
                      Let me in
                    </Button>
                  </Box></>
                )}
              </div>

            </div>
            {((accounts && accounts.username) || window.top !== window.self) && <div className="d-flex flex-column-fluid flex-column flex-center">
              <Box pt={2} className="w-100">
                <Box mb={3}>
                  <Typography variant="h3" gutterBottom>
                    <span className="undline">Warehouse</span> App
                  </Typography>
                </Box>
                <Box py={1}>
                  <Box>
                    <form
                      id="headerjob"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                      key={resetvalues}
                    >
                      <Grid container>
                        <Grid item xs={12} spacing={2}>
                          <Box pb={2}>
                            <AutocompleteController
                              name="warehouse_name"
                              control={control}
                              Values={wareHouseNames}
                              required={true}
                              disabled={((accounts && accounts.username) || window.top !== window.self) ? false : true}
                              getValueChanged={(data) => {
                                getWareHouseId(data);
                              }}
                              error={errors.warehouse_name}
                              rules={{ required: true }}
                              id="warehouse_name"
                              label="Warehouse Name"
                            />
                            {errors.warehouse_name && (
                              <FormValidationErrorMessage
                                errors={errors}
                                errorMessagePrefix="Warehouse Name"
                                name="warehouse_name"
                              />
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} spacing={2}>
                          <Box pb={2}>
                            <Controller
                              as={<TextField />}
                              label="Warehouse Code"
                              placeholder="Warehouse Code"
                              margin="normal"
                              type="text"
                              variant="outlined"
                              size="small"
                              name="warehouse_code"
                              id="warehouse_code"
                              disabled={true}
                              error={errors.warehouse_code}
                              fullWidth
                              required
                              rules={{ required: true }}
                              control={control}
                            />
                            {errors.warehouse_code && (
                              <FormValidationErrorMessage
                                errors={errors}
                                errorMessagePrefix="Warehouse Code"
                                name="warehouse_code"
                              />
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </form>
                  </Box>
                </Box>
                <Box pb={1}>{((accounts && accounts.username) || window.top !== window.self) ? <Footer /> : ""}</Box>
                <Notification notify={notify} setNotify={setNotify} />
              </Box>
            </div>}
          </div>
        </div>
        <div className="content order-1 order-lg-2 d-flex flex-column w-100 pb-0"></div>
      </div>
    </div>
  );
}